import { PureLightTheme } from './schemes/PureLightTheme';
export function themeCreator(theme) {
    return themeMap[theme];
}
var themeMap = {
    PureLightTheme: PureLightTheme
};
